module.exports = "https://static.energy5.com/_next/static/images/percent20-50888fb79056d93e94b2f657e16006dd.png";